// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mic-button {
  position: relative;
  transition: all 0.2s ease;
  cursor: pointer;
  user-select: none;
}

.mic-button:hover {
  transform: scale(1.05);
}

.mic-button:active {
  transform: scale(0.95);
}

.mic-button.recording {
  animation: pulse 2s infinite;
}

.mic-button.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 68, 68, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0);
  }
}

.recording-duration {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  color: #666;
  font-size: 12px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/audiocall/TapToTalk/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".mic-button {\n  position: relative;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  user-select: none;\n}\n\n.mic-button:hover {\n  transform: scale(1.05);\n}\n\n.mic-button:active {\n  transform: scale(0.95);\n}\n\n.mic-button.recording {\n  animation: pulse 2s infinite;\n}\n\n.mic-button.disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(255, 68, 68, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(255, 68, 68, 0);\n  }\n}\n\n.recording-duration {\n  position: absolute;\n  bottom: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #666;\n  font-size: 12px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
